import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
`;

const ContainerTermo = styled.div`
  width: 100%;
  height: 100%;
  max-width: 80rem;
  min-width: 15rem;
  min-height: 30rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: flex-start;
  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  a {
    color: #2d3436;
  }
  a:hover {
    color: #636e72;
  }
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  width: 10rem;
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  width: 80%;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (min-width: 901px) {
    font-size: 1.4rem;
  }
  @media (min-width: 1201px) {
    font-size: 1.6rem;
  }
`;

const H3 = styled.h3`
  text-align: left;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
`;
const H4 = styled.h3`
  text-align: center;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
`;
const H3Details = styled.h3`
  text-align: right;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
`;
const H2 = styled.h2`
  text-align: left;
  font-weight: bold;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
`;
const P2 = styled.p`
  margin-left: 5rem;
`;

export default function ViewContratoLocacao() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>
            CONTRATO DE INTERMEDIAÇÃO NO ALUGUEL OU TROCA DE COTAS EM
            MULTIPROPRIEDADE <br />
          </Titulo>
        </ContainerTitulo>

        <TextWrapper>
          
          <br />
          <br />
          <H3>
            Bem vindo(a)! <br />
            <br />
            Pelo presente instrumento particular, de um lado:
            <br />
            <br />{" "}
            <p>
              <b>LOCADOR</b>, qualificado em sua ficha de cadastro na Plataforma
              e definido conforme a Cláusula 1.1. deste Contrato, doravante
              denominado “Locador”; e, LOCATÁRIO; qualificado em sua ficha de
              cadastro na Plataforma Multicotas ou em plataforma de terceiros e
              definido conforme a Cláusula 1.1. deste Contrato, doravante
              denominado “Locatário”; e e do outro lado: <br />
            </p>
            <p>
              <b>TELLES SOLUÇÕES EM TECNOLOGIA LTDA</b>, sociedade limitada,
              inscrita no CNPJ/MF sob o nº 33.600.316/0001-73, com sede na
              Avenida Geremário Dantas, nº 968, 203 Bloco 4, Jacarepaguá, Rio de
              Janeiro – RJ, CEP: 22743-010, doravante denominada “Multicotas”.
              <br />
            </p>
            <p>
              Locador, Locatário e Multicotas doravante denominados, em
              conjunto, “Partes” e, individualmente, “Parte”. <br />
            </p>
            <p>
              RESOLVEM as Partes celebrar o presente Contrato de Intermediação
              no Aluguel ou Troca de Cotas em Multipropriedade ("Contrato") que
              mutuamente aceitam, outorgam e se obrigam a cumprir integralmente,
              conforme os termos e condições estabelecidos a seguir: <br />
            </p>
          </H3>
          <H2>1. CONCEITOS E DEFINIÇÕES </H2>
          <H3>
            <p>
              1.1. <u>Glossário de Termos.</u> Para o escopo do presente Termo,
              as palavras com inicial em letra maiúscula utilizadas no texto
              deste Termo terão o significado abaixo, quando um significado não
              lhe for atribuído no próprio texto. Os termos utilizados no
              singular ou no plural terão o mesmo significado.
            </p>
            <p>
              i.<u> Termo:</u> Compreende o presente Termos de Uso;
            </p>
            <p>
              ii. <u>Contrato:</u> Compreende o Contrato de Intermediação no
              Aluguel ou Troca de Cotas em Multipropriedade celebrado entre
              Multicotas, Locador e Locatário;
            </p>
            <p>
              iii. <u>Multicotas:</u> Consiste na plataforma que auxilia a
              locação e a troca de períodos de utilização em multipropriedades;
            </p>
            <p>
              iv. <u>Cotista</u>: É o titular de uma multipropriedade ou dono de
              tempo compartilhado (“timeshare”);
            </p>
            <p>
              v. <u>Cota:</u> direito dado a um cotista para usufruir de uma
              hospedagem;
            </p>
            <p>
              vi. <u>Não Cotista:</u> Aquele que não é titular de
              multipropriedade;
            </p>
            <p>
              vii. <u>Locador:</u> É o Cotista que deseja ceder, a título
              oneroso, seu período de utilização para terceiro, que poderá ser
              outro Cotista ou Não Cotista;
            </p>
            <p>
              viii. <u>Locatário:</u> É o Cotista ou o Não Cotista que deseja
              utilizar o período de utilização de um Cotista;{" "}
            </p>
            <p>
              ix. <u>Usuário:</u> Aquele que utiliza os serviços da Multicotas,
              independente se na qualidade de Cotista, Não Cotista, Locador ou
              Locatário; e
            </p>
            <p>
              x. <u>Hospedagem:</u> Compreende o hotel ou resort que administra
              determinada multipropriedade.
            </p>

            <p>
              1.2. <u> Observações.</u> O Usuário concorda que:
            </p>
            <p>
              (i) os títulos deste Termo servem apenas para conveniência de
              referência e não limitarão ou afetarão o significado das
              cláusulas, parágrafos ou itens aos quais se aplicam; e
            </p>
            <p>
              (ii) referências a quaisquer documentos ou outros instrumentos
              incluem todas as suas alterações, aditamentos, substituições e
              consolidações e respectivas complementações existentes na data de
              assinatura deste Termo, salvo se expressamente disposto de forma
              diversa neste Termo.
            </p>
          </H3>
          <H2>2. OBJETO </H2>
          <H3>
            {" "}
            <p>
              {" "}
              2.1. <u>Descrição dos Serviços.</u> O presente Contrato tem por
              objeto a prestação de serviços de intermediação no aluguel ou na
              troca de cotas em multipropriedade, assim descrito:
            </p>
            <p>
              ▪ Auxílio aos Cotistas, titulares de multipropriedade, a alugar
              seus períodos de utilização dessas propriedades para terceiros,
              bem como encontrar outros Cotistas que queiram trocar seus
              respectivos períodos.
            </p>
            <p>
              {" "}
              2.2. <u>Forma de Disponibilização.</u> O Cotista que disponibiliza
              seu período de utilização na multipropriedade para a Multicotas
              reconhece e concorda que tal disponibilidade pode ser divulgada
              tanto na plataforma própria da Multicotas quanto em plataformas de
              reserva online de terceiros (OTAs), conforme estipulado nos Termos
              de Uso da Multicotas.
            </p>
            <p>
              {" "}
              2.3. <u>Papel da Multicotas.</u> A Multicotas atua apenas como
              intermediária da transação entre o Cotista (Locador) e um
              terceiro, que poderá ser outro Cotista ou não (Locatário). A
              Multicotas não atua como locadora, locatária ou vendedora de
              multipropriedade, nem como hotel, resort ou qualquer outro meio de
              hospedagem, sendo mera facilitadora da conexão entre as Partes.
            </p>
            <p>
              {" "}
              2.4. <u>Papel das Partes no Aluguel.</u> Para os fins deste
              Contrato, o 'Locador' é o Cotista que é titular da
              multipropriedade e que disponibiliza seu período de utilização
              para locação através da Multicotas. O 'Locatário' é a parte que
              aluga e utiliza o período disponibilizado pelo Locador.
            </p>
            <p>
              {" "}
              2.5. <u>Papel das Partes na Troca.</u> No caso de uma troca de
              períodos de utilização entre dois Cotistas, ambos serão
              considerados simultaneamente como 'Locadores' e 'Locatários'. Cada
              Cotista será um 'Locador' no que se refere ao período de
              utilização da multipropriedade que está disponibilizando para a
              troca, e será um 'Locatário' no que se refere ao período de
              utilização da multipropriedade que está recebendo em troca.
            </p>
            <p>
              {" "}
              2.6. <u>Limitações de Responsabilidade.</u> A responsabilidade da
              Multicotas é restrita à execução dos seus serviços, não podendo
              ser responsabilizadas por ações e/ou omissões de terceiros
              envolvidos, tais como, mas não apenas, Locadores, Locatários,
              Hospedagens ou plataformas de terceiros.
            </p>
          </H3>
          <H2>3. OBRIGAÇÕES DA MULTICOTAS </H2>
          <H3>
            <p>
              {" "}
              3.1. <u>Obrigações da Multicotas.</u> Constituem obrigações da
              Multicotas:
            </p>
            <p>
              i. Prestar os Serviços de intermediação para a locação ou troca de
              cotas em multipropriedade, conforme estabelecido neste Contrato,
              nos Termos de Uso e em conformidade com as leis e regulamentos
              aplicáveis;
            </p>
            <p>
              ii. Facilitar a comunicação e a transação entre o Locador e o
              Locatário, garantindo que ambas as partes estejam cientes dos
              termos e condições da locação ou troca; e
            </p>
            <p>
              iii. Realizar os pagamentos devidos ao Locador conforme acordado
              neste Contrato e nos Termos de Uso, nos prazos estabelecidos;
            </p>
            <p>
              {" "}
              3.2. <u>Responsabilidade da Multicotas.</u> A Multicotas não será
              responsável por qualquer ação ou omissão do Locador ou do
              Locatário que esteja em violação deste Contrato, dos Termos de
              Uso, ou das leis e regulamentos aplicáveis, exceto se
              expressamente previsto neste Contrato ou nos Termos de Uso.
            </p>
          </H3>
          <H2>4. OBRIGAÇÕES DO LOCADOR </H2>
          <H3>
            <p>
              4.1. <u>Obrigações do Locador.</u> Constituem obrigações do
              Locador:{" "}
            </p>
            <p>
              i. Disponibilizar sua cota em multipropriedade para aluguel ou
              troca para a Multicotas, que poderá divulgar na sua própria
              plataforma ou na de terceiros respeitando as condições
              estabelecidas neste Contrato e nos Termos de Uso da Multicotas,
              bem como observar as políticas das plataformas terceiras;
            </p>
            <p>
              ii. Fornecer informações verdadeiras e completas à Multicotas
              sobre a sua cota em multipropriedade e manter tais informações
              atualizadas;
            </p>
            <p>
              iii. Cumprir integralmente suas obrigações perante o Locatário,
              conforme acordado neste Contrato e nos Termos de Uso; e
            </p>
            <p>
              iv. Indenizar e isentar a Multicotas de qualquer responsabilidade
              decorrente de suas ações ou omissões que resultem em violação
              deste Contrato e/ou dos Termos de Uso.
            </p>
          </H3>
          <H2>5. OBRIGAÇÕES DO LOCATÁRIO </H2>
          <H3>
            <p>
              5.1. <u>Obrigações do Locatário.</u> Constituem obrigações do
              Locatário:
            </p>
            <p>
              i. Respeitar todas as condições de aluguel ou troca da cota em
              multipropriedade, conforme acordado neste Contrato e nos Termos de
              Uso da Multicotas;
            </p>
            <p>
              ii. Fornecer informações verdadeiras e completas à Multicotas
              sobre a sua identidade e manter tais informações atualizadas;
            </p>
            <p>
              iii. Cumprir integralmente suas obrigações perante o Locador,
              conforme acordado neste Contrato e nos Termos de Uso; e
            </p>
            <p>
              iv. Indenizar e isentar a Multicotas de qualquer responsabilidade
              decorrente de suas ações ou omissões que resultem em violação
              deste Contrato e/ou do Contrato de Aluguel ou Troca celebrado com
              o Locador.
            </p>
          </H3>
          <H2>6. PREÇO E CONDIÇÕES DE PAGAMENTO </H2>
          <H3>
            <p>
              6.1. <u>Pagamento.</u> O Locatário concorda em pagar à Multicotas
              o valor acordado pelo aluguel ou troca da cota em
              multipropriedade, conforme estabelecido neste Contrato e nos
              Termos de Uso da Multicotas.
            </p>
            <p>
              6.2. <u>Repasse ao Locador.</u> A Multicotas concorda em repassar
              ao Locador o valor devido pelo aluguel da cota em
              multipropriedade, conforme estabelecido neste Contrato e nos
              Termos de Uso da Multicotas.
            </p>
          </H3>
          <H2>7. VIGÊNCIA </H2>
          <H3>
            <p>
              7.1. <u>Vigência do Contrato.</u> Este Contrato entrará em vigor
              na data do Aceite Eletrônico e permanecerá em vigor até o término
              do período de locação ou troca acordado na Multicotas, a menos que
              seja rescindido antecipadamente em conformidade com as disposições
              deste Contrato ou nos Termos de Uso.
            </p>
            <p>
              7.2. <u>Alterações.</u> Qualquer alteração ou modificação a este
              Contrato só será válida se estiver em um aditivo escrito e com
              aceite de todas as Partes, desde que expressamente permitido nos
              Termos de Uso. As alterações ou modificações devem respeitar os
              termos e condições previstos neste Contrato e nos Termos de Uso da
              Multicotas.
            </p>
          </H3>
          <H2>8. RESCISÃO </H2>
          <H3>
            <p>
              8.1. <u>Condições para Rescisão.</u> Este Contrato somente pode
              ser rescindido pelas Partes de acordo com os procedimentos e
              condições estabelecidos nos Termos de Uso da Multicotas para
              desistência, cancelamento e/ou alteração da reserva.
            </p>
            <p>
              8.2. <u>Efeitos da Rescisão.</u> Em caso de rescisão deste
              Contrato, todas as obrigações, responsabilidades e direitos das
              Partes que, por sua natureza, deveriam sobreviver à rescisão deste
              Contrato, continuarão em pleno vigor e efeito após tal rescisão.
              Além disso, aplicar-se-ão os termos e condições previstos nos
              Termos de Uso da Multicotas, inclusive, mas não se limitando, às
              penalidades previstas em caso de rescisão.
            </p>
          </H3>
          <H2>9. PENALIDADES </H2>
          <H3>
            <p>
              9.1. <u>Violação do Contrato e/ou Termos de Uso.</u> Qualquer
              violação deste Contrato ou dos Termos de Uso da Multicotas por
              qualquer das Partes resultará na aplicação das penalidades
              previstas nos Termos de Uso da Multicotas.
            </p>
            <p>
              9.2. <u>Reconhecimento das Partes.</u> As Partes reconhecem que as
              penalidades estabelecidas nos Termos de Uso são uma estimativa
              razoável dos danos que a Multicotas ou a Parte Violada poderia
              sofrer em decorrência da violação deste Contrato e/ou dos Termos
              de Uso.
            </p>
          </H3>
          <H2>10. DISPOSIÇÕES GERAIS </H2>
          <H3>
            <p>
              10.1.<u> Contrato e Termos de Uso.</u> Este Contrato e os Termos
              de Uso da Multicotas são indissociáveis e complementares. Ao
              proceder o Aceite Eletrônico deste Contrato ou ao utilizar a
              Plataforma Multicotas, a Parte declara que leu, entendeu e
              concorda com os Termos de Uso da Multicotas. A Parte reconhece que
              os Termos de Uso estão disponíveis para consulta a qualquer
              momento no seguinte link:
              <a href="https://proprietario.multicotas.com.br/termodeuso">
                https://proprietario.multicotas.com.br/termodeuso
              </a>
              , e se compromete a revisá-los regularmente para estar ciente de
              qualquer alteração.
            </p>
            <p>
              10.2. <u>Integralidade.</u> Os Anexos, os Termos de Uso e o
              comprovante de reserva, se houver, fazem parte integrante deste
              Contrato. Tais documentos contêm informações importantes e
              condições adicionais que regem os direitos e obrigações das Partes
              e devem ser lidos e compreendidos juntamente com este Contrato.
            </p>
            <p>
              10.3. <u>Único Instrumento Legal.</u> Este Contrato e os Termos de
              Uso representam o único instrumento legal entre as Partes e
              substituem todos os entendimentos, acordos ou contratos
              anteriores, tanto escritos quanto orais, entre as Partes,
              relativos ao objeto deste Contrato. Nenhuma modificação ou
              alteração deste Contrato e dos Termos de Uso será válida a menos
              que seja feita por escrito e firmada pelas Partes.
            </p>
            <p>
              10.4. <u>Divergências de Disposições.</u> Na hipótese de ocorrerem
              divergências entre o presente Contrato e quaisquer outros
              documentos prevalecerá o disposto no presente Contrato.
            </p>
            <p>
              10.5. <u>Autonomia das Disposições.</u> Se qualquer disposição do
              presente Contrato for considerada nula, ilegal ou inexequível nos
              termos da legislação pertinente, a disposição em questão será
              ineficaz tão somente na medida da nulidade, ilegalidade ou
              inexequibilidade daquela disposição, e não afetara quaisquer
              outras disposições aqui contidas.
            </p>
            <p>
              10.6. <u>Alterações.</u> As Partes concordam que nenhuma alteração
              do presente Contrato, ou ausência no exercício dos direitos aqui
              previstos por qualquer das Partes, será havida por novação de
              qualquer obrigação ou disposições aqui contidas, salvo se de outra
              forma estabelecido pelas Partes.
            </p>
            <p>
              10.7. <u>Tolerância.</u> A mera tolerância por quaisquer das
              Partes ao inadimplemento de obrigações da Parte contrária não
              significará renúncia de quaisquer direitos, exceto se
              expressamente acordado desta maneira.
            </p>
            <p>
              10.8. <u>Tributos.</u> Cada Parte fica responsável pela declaração
              e recolhimento de seus respectivos tributos em virtude dos
              pagamentos realizados em virtude da execução do Contrato.
            </p>
            <p>
              10.9. <u> Foro.</u> Este Contrato será regido e interpretado de
              acordo com as Leis do Brasil. As Partes elegem o foro da Comarca
              da Capital do Estado do Rio de Janeiro, para dirimir quaisquer
              dúvidas decorrentes deste Contrato.
            </p>
          </H3>
          <H2>11. ACEITE ELETRÔNICO </H2>
          <H3>
            <p>
              11.1. <u> Aceite Eletrônico.</u> As Partes acordam expressamente
              que este Contrato é celebrado e aceito eletronicamente,
              dispensando a necessidade de assinaturas físicas ou eletrônica. O
              aceite do Contrato ocorrerá mediante a manifestação de
              concordância expressa ou tática da Parte Receptora, após envio de
              e-mail com o Contrato.
            </p>
            <p>
              11.2. <u> Manifestação do Aceite.</u> Após o envio deste Contrato
              à Parte via e-mail, a mesma deverá manifestar expressamente
              qualquer discordância em relação aos termos e condições aqui
              estabelecidos no prazo máximo de 3 (três) dias úteis, contados a
              partir da data de recebimento do e-mail contendo o Contrato. A
              manifestação de discordância deverá ser feita por escrito, através
              de resposta ao e-mail de envio do Contrato, detalhando
              especificamente os pontos de desacordo. Na hipótese de a Parte não
              se manifestar dentro do prazo estipulado no item 2.1, será
              considerado que a mesma aceitou tacitamente todos os termos e
              condições do Contrato.
            </p>
            <p>
              11.3. <u> Validade.</u> A manifestação de aceite eletrônico terá a
              mesma validade e eficácia jurídica que uma assinatura manuscrita,
              conforme estabelecido pelas legislações aplicáveis, incluindo, mas
              não se limitando à Medida Provisória nº 2.200-2/2001, que institui
              a Infraestrutura de Chaves Públicas Brasileira (ICP-Brasil). Este
              Contrato, uma vez aceito eletronicamente pelas partes, será
              considerado para todos os fins de direito como um documento
              original, vinculando as partes aos termos e condições aqui
              estabelecidos, com a mesma força e efeito de um documento assinado
              em papel.
            </p>
            <p>
              11.4. <u> Data e Hora.</u> A data e hora do aceite eletrônico,
              assim como os registros eletrônicos associados, serão considerados
              como prova do acordo e da formação do Contrato entre as Partes.
            </p>
            <p>
              11.5. <u> Declaração das Partes.</u> Cada Parte declara que leu,
              compreendeu e concordou voluntariamente com todos os termos e
              condições deste Contrato, reconhecendo que seu aceite eletrônico é
              plenamente informado e realizado de forma livre e espontânea.
            </p>
          </H3>
          <H3>
            <p>
              As Partes estão assim justas e contratadas e se comprometem a
              cumprir todas as obrigações estabelecidas neste Contrato e nos
              Termos de Uso.
            </p>
          </H3>
          <H4>
            <p>Rio de Janeiro, na data do aceite eletrônico.</p>
          </H4>
          <H4>
            <p>[Dispensada a assinatura mediante Aceite Eletrônico] </p>
          </H4>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
